import type { ResourcePool, TurnActionUsage } from "../types";

export function createEmptyResourcePool(): ResourcePool {
  return {
    food: 0,
    production: 0,
    trade: 0,
    science: 0,
    culture: 0,
  };
}

export function createEmptyTurnActionUsage(): TurnActionUsage {
  return {
    landActions: 0,
    deploymentActions: 0,
    governanceActions: 0,
    eventsPlayed: 0,
    eventAuthorizationLanesUsed: [],
    attacksMadeFromLanes: [],
  };
}
